import { Injectable } from '@angular/core';
import { convertFromSapDate } from 'src/app/lego-utils';
import { IAdapter } from 'src/app/models';
import { MaterialWhereUsed } from 'src/app/models/domain';
import { YPMMATERIALWHEREUSEDSRVItems } from 'src/generated-clients/material_whereused';

@Injectable({
  providedIn: 'root',
})
export class MaterialWhereUsedAdapter implements IAdapter<
  MaterialWhereUsed,
  YPMMATERIALWHEREUSEDSRVItems
> {
  public adaptToDomain(item: YPMMATERIALWHEREUSEDSRVItems): MaterialWhereUsed {
    return new MaterialWhereUsed(
      item.material ?? '',
      item.materialType ?? '',
      item.description ?? '',
      item.materialGroup ?? '',
      convertFromSapDate(item.globalLaunchDate) ?? undefined,
      convertFromSapDate(item.marketExitDate) ?? undefined
    );
  }
}
